import { 
  Buildings, 
  Wrench, 
  Wall, 
  UsersThree, 
  Door,
  HardHat
} from "@phosphor-icons/react";

const services = [
  {
    id: 1,
    icon: Buildings,
    title: "Obra Civil y Adecuaciones Industriales",
    description: "Construcción y modificación de áreas operativas, fundidas de concreto, reparación de losas, construcción de zapatas, bases y pedestales.",
    items: ["Construcción de bodegas", "Adecuación de CEDIS y plantas", "Divisiones en drywall", "Cerramientos industriales"],
    color: "#C92127",
    span: "lg:col-span-8"
  },
  {
    id: 2,
    icon: Wrench,
    title: "Mantenimiento Locativo",
    description: "Reparaciones locativas generales, corrección de fisuras y grietas, impermeabilización de cubiertas y tanques.",
    items: ["Sellado de juntas", "Recuperación de estibas", "Reposición de enchapes"],
    color: "#1E3A8A",
    span: "lg:col-span-4"
  },
  {
    id: 3,
    icon: Wall,
    title: "Pisos Industriales",
    description: "Aplicación de pisos industriales, reparación de pisos en concreto, tratamientos epóxicos y recubrimientos de alto desempeño.",
    items: ["Tratamientos epóxicos", "Protección de superficies", "Recubrimientos técnicos"],
    color: "#EA580C",
    span: "lg:col-span-4"
  },
  {
    id: 4,
    icon: UsersThree,
    title: "Apoyo Operativo",
    description: "Suministro de personal operativo, limpieza técnica industrial, apoyo productivo y logístico.",
    items: ["Personal operativo", "Limpieza técnica", "Mantenimiento preventivo y correctivo"],
    color: "#059669",
    span: "lg:col-span-4"
  },
  {
    id: 5,
    icon: Door,
    title: "Instalaciones Técnicas",
    description: "Puertas y ventanería, estructuras metálicas livianas, mobiliario técnico, pintura industrial y señalización SST.",
    items: ["Estructuras metálicas", "Pintura industrial", "Señalización SST"],
    color: "#7C3AED",
    span: "lg:col-span-4"
  }
];

export function ServicesSection() {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="section-padding bg-slate-50 relative overflow-hidden"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, #0F172A 1px, transparent 0)`,
            backgroundSize: '40px 40px'
          }}
        />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-12 h-0.5 bg-[#C92127]" />
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
              Nuestros Servicios
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 mb-6">
            Soluciones <span className="text-[#C92127]">integrales</span> para su operación
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Atendemos necesidades de mantenimiento, adecuaciones, obra civil, soporte operativo 
            e intervenciones técnicas, siempre enfocados en proteger la operación del cliente.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={service.id}
                data-testid={`service-card-${service.id}`}
                className={`${service.span} card p-8 rounded-xl group cursor-pointer`}
                style={{
                  animationDelay: `${index * 0.1}s`
                }}
              >
                {/* Icon */}
                <div 
                  className="w-14 h-14 rounded-lg flex items-center justify-center mb-6 transition-transform group-hover:scale-110"
                  style={{ backgroundColor: `${service.color}15` }}
                >
                  <Icon size={28} weight="duotone" style={{ color: service.color }} />
                </div>

                {/* Content */}
                <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-3 group-hover:text-[#C92127] transition-colors">
                  {service.title}
                </h3>
                <p className="text-slate-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Items */}
                <ul className="space-y-2">
                  {service.items.map((item, i) => (
                    <li key={i} className="flex items-center gap-2 text-sm text-slate-500">
                      <span 
                        className="w-1.5 h-1.5 rounded-full"
                        style={{ backgroundColor: service.color }}
                      />
                      {item}
                    </li>
                  ))}
                </ul>

                {/* Hover Accent */}
                <div 
                  className="absolute bottom-0 left-0 right-0 h-1 rounded-b-xl opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{ backgroundColor: service.color }}
                />
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a
            href="#contacto"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#contacto")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="btn-primary inline-flex items-center gap-2"
            data-testid="services-cta"
          >
            <HardHat size={20} weight="duotone" />
            Solicitar Servicio
          </a>
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
